import { Component, OnDestroy, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { ThemePreferenceService } from 'src/app/Services/theme-preference.service';

interface HelpLink {
  label: string;
  description: string;
  route: string;
  icon: string;
}

@Component({
  selector: 'app-not-found',
  templateUrl: './not-found.component.html',
  styleUrls: ['./not-found.component.scss']
})
export class NotFoundComponent implements OnInit, OnDestroy {
  attemptedUrl = '';
  selectedThemeMode: 'light' | 'dark' = 'light';
  private themeSubscription?: Subscription;

  readonly helpLinks: HelpLink[] = [
    {
      label: 'Home',
      description: 'Browse featured guides and return to your feed.',
      route: '/',
      icon: 'home'
    },
    {
      label: 'How it works',
      description: 'See how Flowchest turns know-how into step-by-step guides.',
      route: '/how-it-works',
      icon: 'play_circle'
    },
    {
      label: 'FAQ & Support',
      description: 'Answers about accounts, purchases, and publishing.',
      route: '/faq',
      icon: 'help'
    },
    {
      label: 'Contact us',
      description: 'Reach the Flowchest team if something looks broken.',
      route: '/contact-us',
      icon: 'mail'
    }
  ];

  constructor(
    private router: Router,
    private themePreference: ThemePreferenceService
  ) {}

  ngOnInit(): void {
    const url = this.router.url || '';
    this.attemptedUrl = url === '/404' ? '' : url.split('?')[0];

    const theme = this.themePreference.initializeFromStorage();
    this.selectedThemeMode = theme;

    this.themeSubscription = this.themePreference.themeChanges$.subscribe((mode) => {
      this.selectedThemeMode = mode === 'dark' ? 'dark' : 'light';
    });
  }

  ngOnDestroy(): void {
    this.themeSubscription?.unsubscribe();
  }

  goTo(route: string): void {
    void this.router.navigateByUrl(route);
  }

  goHome(): void {
    void this.router.navigateByUrl('/');
  }

  goBack(): void {
    if (typeof window !== 'undefined' && window.history.length > 1) {
      window.history.back();
      return;
    }
    this.goHome();
  }
}
